import { Box } from '@mui/material'
import { useSelector } from 'react-redux'
import { RootState } from '../../../store'
import SettingsMyCompany from './settings-my-company/settings-my-company.component'
import SettingsUserManagement from './settings-user-management.component'
import SettingsBilling from './settings-billing/settings-billing.component'
import CustomSetting from './custom-setting/custom-setting.component'

const SettingsDetails = () => {
  const tabIndex = useSelector((state: RootState) => state.company.tabIndex)

  const content =
    tabIndex === 1 ? (
      <SettingsUserManagement />
    ) : tabIndex === 2 ? (
      <SettingsBilling />
    ) : tabIndex === 3 ? (
      <CustomSetting />
    ) : (
      <SettingsMyCompany />
    )

  return (
    <Box
      sx={{
        height: '100%',
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
      }}
    >
      {content}
    </Box>
  )
}

export default SettingsDetails
